import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var UiMenuDotsThreeVIcon24Regular = forwardRefAndName('UiMenuDotsThreeVIcon24Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 24
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M13.878 4.5a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M13.877 12.003a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M12.002 21.38a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
    }))
  );
});